import Model from "../base/model";

class SimulateUnit extends Model {
  resourceName() {
    return "simulate_unit";
  }

  fields() {
    return {
      cod_main: "",
      recommended_ind: "",
      shipping_table: "",
      shipping_table_code: "",
      shipping_table_type_name: "",
      shipping_table_type_dsc: "",
      service_level_code: "",
      service_level: "",
      transporter: "",
      transporter_code: "",
      transport_operation_code: "",
      transporter_ext_code: "",
      weight: "",
      shipping_id: "",
      deadline_qty: "",
      local_delivery_time_code: "",
      delivery_time_code: "",
      rate_value: "",
      rate_shipping: "",
      weight_shipping_value: "",
      shipping_value: "",
      root_id: "",
    };
  }
}
export default new SimulateUnit();
